var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40864 5.99915L11.7045 1.71268C12.0962 1.32088 12.0962 0.685649 11.7045 0.293849C11.3127 -0.0979498 10.6776 -0.0979498 10.2859 0.293849L6 4.59031L1.71414 0.293849C1.3224 -0.0979498 0.687256 -0.0979498 0.295513 0.293849C-0.0962308 0.685649 -0.0962308 1.32088 0.295513 1.71268L4.59136 5.99915L0.295513 10.2856C0.106383 10.4732 0 10.7286 0 10.995C0 11.2614 0.106383 11.5168 0.295513 11.7044C0.483098 11.8936 0.738447 12 1.00483 12C1.27121 12 1.52656 11.8936 1.71414 11.7044L6 7.40799L10.2859 11.7044C10.4734 11.8936 10.7288 12 10.9952 12C11.2616 12 11.5169 11.8936 11.7045 11.7044C11.8936 11.5168 12 11.2614 12 10.995C12 10.7286 11.8936 10.4732 11.7045 10.2856L7.40864 5.99915Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWindow);
export default __webpack_public_path__ + "static/media/x-window.8c6d3a1d908b7b362c026d142321e0c7.svg";
export { ForwardRef as ReactComponent };